<template>
  <main class="registered-data-container">
    <section class="data-form">
      <div class="field half">
				<label for="date">{{$t('reference_date')}}:</label><br>
				<input
          id="DTREFECUSTO"
          type="date"
          v-model="formData.DTREFECUSTO"
        />
			</div>
      <!--
      <div class="field half">
        <label for="groupProdLimit">{{$t('grouping_of_products_for_safety_limit_menu_freezing')}}:</label>
        <br />
        <v-select
          id="groupProdLimit"
          :getOptionLabel="o => `${o.CDGRUPPROD} - ${o.NMGRUPPROD}`"
          v-model="formData.groupProdLimit"
          :options="formData.groupProdLimitOptions"
          label="NMGRUPPROD"
          @input="onChangeGroupProdLimit()"
        ></v-select>
      </div>
      -->
      <div class="field half">
        <label for="costType">{{$t('cost_type')}}</label>
        <br />
        <v-select
          id="costType"
          v-model="formData.costType"
          :options="formData.costTypeOptions"
          label="NMTIPOCUSTO"
          @input="onChangeCostType()"
          @search="onSearchCostType"
        ></v-select>
      </div>

      <div class="field half">
        <label for="calcUnitCost">{{$t('calc_cost_based_on_unit')}}:</label>
        <br />
        <v-select
          id="calcUnitCost"
          :getOptionLabel="o => `${o.NMFILIAL}`"
          v-model="formData.CDFILICUSTO"
          :options="formData.calcUnitCostOptions"
          label="CDFILICUSTO"
        ></v-select>
      </div>      

      <div class="field half">
        <label for="defaultCost">{{$t('standard_cost')}}:</label>
        <br />
        <input
          id="defaultCost"
          @change="onChangeDefaultCost"
          type="number"
          v-model="formData.VRCUSTPADR"
        />
      </div>
      
      <div class="field half">
        <label for="minPercent">{{$t('minimum_percentage')}} (%):</label>
        <br />
        <input
          id="minPercent"
          @change="onChangeMinPercent"
          type="number"
          v-model="formData.PERC_CUSTO_MIN"
          min="0"
          max="100"
        />
      </div>
      
      <div class="field half">
        <label for="maxPercent">{{$t('maximum_percentage')}} (%):</label>
        <br />
        <input
          id="maxPercent"
          @change="onChangeMaxPercent"
          type="number"
          v-model="formData.PERC_CUSTO_MAX"
          min="0"
          max="100"
        />
      </div>
      
      <div class="field half">
        <label for="minValue">{{$t('minimum_value')}}:</label>
        <br />
        <input
          id="minValue"
          @change="onChangeMinCost"
          type="number"
          v-model="formData.VLR_CUSTO_MIN"
        />
      </div>
      
      <div class="field half">
        <label for="maxValue">{{$t('maximum_value')}}:</label>
        <br />
        <input
          id="maxValue"
          @change="onChangeMaxCost"
          type="number"
          v-model="formData.VLR_CUSTO_MAX"
        />
      </div>
      
      <div class="field half">
        <label for="maxValue">{{$t('days_to_be_frozen')}}: 
          <span v-if="!isNotFreezeble" v-text="' '+$t('maximum_value_must_be_less_than_or_equal_to')+' ' + formData.MAX_VLR_CONGELADO"></span>
        </label>
        <br />
        <input
          id="frozenDays"
          type="number"
          step="1"
          :disabled="isNotFreezeble"
          @change="onChangeFreez"
          :min="formData.MIN_VLR_CONGELADO"
          :max="formData.MAX_VLR_CONGELADO"
          v-model="formData.VLR_CONGELADO"
        />
      </div>

      <div class="field half">
        <label for="linkCommonDishes">{{$t('source_scenario_for_linking_common_dish_types_between_services')}}:</label>
        <br />
        <v-select
          id="linkCommonDishes"
          :getOptionLabel="o => `${o.NRCENARIOCARD} ${o.DTCENARIOCARD}`"
          v-model="formData.linkCommonDishes"
          :options="formData.linkCommonDishesOptions"
          label="NRCENARIOCARD"
        ></v-select>
      </div>
      
    </section>
  </main>
</template>

<script>
import Util from "@/application/libs/util";
import vSelect from "vue-select";
import RegisteredDataController from "../controllers/RegisteredDataController";
import moment from "moment";
import EventModule from "@/application/libs/eventModule";

export default {
  components: {"v-select": vSelect},
  props: ["updateRegisteredData"],
  name: "RegisteredData",
  created() {},
  updated() {
  },
  beforeDestroy(){
    EventModule.$off(
      "next-step-optimizer", this.onNextStep
    );
  },
  mounted() {
    RegisteredDataController.searchCostType(null, () => {}, this).then(() => {
        this.formData.costType =
          this.formData.costTypeOptions.length &&
          this.formData.costTypeOptions[0];

        this.getDefaultData();
        this.isNotFreezeble = this.checkFreezability(this.formData);
        Util.setBackOfficeData("VLR_CONGELADO", this.formData.VLR_CONGELADO);
        Util.setFilterInSession("VLR_CONGELADO", this.formData.VLR_CONGELADO);
    });
    /*
    RegisteredDataController.searchGroupProdLimit(() => {}, this).then(() => {
        RegisteredDataController.getGroupProdCard().then((response) => {
          if (this.formData.groupProdLimitOptions.length && 
          this.formData.groupProdLimitOptions[0]) {
            this.formData.groupProdLimit = this.formData.groupProdLimitOptions
              .find(option => option.NRCENARIOCARD == response[0].NRCENARIOCARD);
          }
          this.formData.NRCENARIOCARD = response[0].NRCENARIOCARD;
        });
    });*/
    
    this.getDataLinkCommonDishes();
    this.getDataCalcUnitCost();
    EventModule.$on("next-step-optimizer", this.onNextStep);
  },
  data() {
    return {
      formData: {
        DSDNSCARDOTIMIZADO: Util.getFilterInSession().DSDNSCARDOTIMIZADO,
        DTREFECUSTO: null,
        costTypeOptions: [],
        costType: null,
        groupProdLimitOptions: [],
        groupProdLimit: null,
        linkCommonDishesOptions: [],
        linkCommonDishes: null,
        calcUnitCostOptions: [],
        CDGRUPPRODOTMCARD: null,
        VRCUSTPADR: null,
        CDFILICUSTO: null,
        PERC_CUSTO_MAX: null,
        PERC_CUSTO_MIN: null,
        VLR_CUSTO_MIN: null,
        VLR_CUSTO_MAX: null,
        VLR_CONGELADO: 0,
        MIN_VLR_CONGELADO: 0,
        MAX_VLR_CONGELADO: 0,
        P_DIA_SEMANA: null,
      },
      isNotFreezeble: false
    };
  },
  methods: {
    onNextStep: function(stepIndex) {
      if (stepIndex == 1) {
        Util.debounce.clearDebounce();
        this.saveFormData();
      }
    },
    onSearchCostType: Util.debounce(function(search, loading) {
      return RegisteredDataController.searchCostType(search, loading, this);
    }, 400),
    checkFreezability: function(formData){
      RegisteredDataController.checkFreezability(formData).then(result =>{
        result = result.dataset.data[0];
        this.isNotFreezeble = result.PERMITE_CONGELAR != 'S';
        let LASTDAY = parseInt(result.LASTDAY);
        let QTDIAS = parseInt(result.QTDIAS);
        this.formData.MAX_VLR_CONGELADO = LASTDAY;
        this.formData.VLR_CONGELADO = QTDIAS > LASTDAY ? LASTDAY : QTDIAS;
        this.formData.VLR_CONGELADO = this.isNotFreezeble ? 0 : this.formData.VLR_CONGELADO;
      });
    },
    onChangeFreez: function(){
      this.formData.VLR_CONGELADO = parseInt(this.formData.VLR_CONGELADO);
      if(this.formData.VLR_CONGELADO > this.formData.MAX_VLR_CONGELADO){
        this.formData.VLR_CONGELADO = parseInt(JSON.stringify(JSON.parse(this.formData.MAX_VLR_CONGELADO)));
      }else if(this.formData.VLR_CONGELADO < this.formData.MIN_VLR_CONGELADO){
        this.formData.VLR_CONGELADO = parseInt(JSON.stringify(JSON.parse(this.formData.MIN_VLR_CONGELADO)));
      }
      
      this.formData.VLR_CONGELADO = Util.isInvalidNumber(this.formData.VLR_CONGELADO)? 0 : this.formData.VLR_CONGELADO;
      Util.setFilterInSession("VLR_CONGELADO", this.formData.VLR_CONGELADO)
    },

    getDataLinkCommonDishes: function() {
      RegisteredDataController.searchLinkCommonDishes(() => {}, this).then((res) => {
        this.formData.linkCommonDishes =
          (this.formData.linkCommonDishesOptions.length &&
          this.formData.linkCommonDishesOptions[0]) || null;
      });
    },
    
    getDataCalcUnitCost: function() {
      RegisteredDataController.searchUnits(() => {}, this).then((res) => {
        this.formData.CDFILICUSTO = (
            this.formData.calcUnitCostOptions.length && null
          ) || null;
      });
    },

    getDefaultData: function() {
      return RegisteredDataController.getDefaultData(this);
    },

    onChangeCostType() {
      // this.saveData();
    },

    onChangeGroupProdLimit() {
      RegisteredDataController.updateGrupProdCard(this).then(() => {
        this.isNotFreezeble = this.checkFreezability(this.formData);
      });
    },

    onChangeDefaultCost() {
      this.formData.VRCUSTPADR = parseFloat(this.formData.VRCUSTPADR).toFixed(2);
	    this.onChangeMinPercent();
      this.onChangeMaxPercent();
      // this.saveData();
    },

    onChangeDnsConfig() {
      // this.saveData();
    },

    onChangeMinPercent() {
      let defaultCost = this.formData.VRCUSTPADR;
      let minPercent = this.formData.PERC_CUSTO_MIN;

      this.formData.VLR_CUSTO_MIN = Number(
        defaultCost - defaultCost * (minPercent / 100)
      );
      this.formData.PERC_CUSTO_MIN = parseFloat(minPercent).toFixed(2);
      // this.saveData();
    },

    onChangeMaxPercent() {
      let defaultCost = this.formData.VRCUSTPADR;
      let maxPercent = this.formData.PERC_CUSTO_MAX;

      this.formData.VLR_CUSTO_MAX =
        Number(defaultCost) + defaultCost * (maxPercent / 100);
      this.formData.PERC_CUSTO_MAX = parseFloat(maxPercent).toFixed(2);
      // this.saveData();
    },

    onChangeMinCost() {
      let defaultCost = this.formData.VRCUSTPADR;
      let minValue = this.formData.VLR_CUSTO_MIN;

      this.formData.PERC_CUSTO_MIN =
        ((defaultCost - minValue) * 100) / defaultCost;
      this.formData.VLR_CUSTO_MIN = parseFloat(minValue).toFixed(2);
      // this.saveData();
    },

    onChangeMaxCost() {
      let defaultCost = this.formData.VRCUSTPADR;
      let maxValue = this.formData.VLR_CUSTO_MAX;

      this.formData.PERC_CUSTO_MAX =
        ((maxValue - defaultCost) * 100) / defaultCost;
      this.formData.VLR_CUSTO_MAX = parseFloat(maxValue).toFixed(2);
      // this.saveData();
    },

    saveData: Util.debounce(function() {
      this.saveFormData();
    }, 3000),

    saveFormData() {
      
      let boData = Util.getFilterInSession();
      
      this.formData.NRTIPOCUSTO = this.formData.costType.CDTIPOCUSTO;
      this.formData.DTREFECUSTO = moment(this.formData.DTREFECUSTO).format('DD/MM/YYYY');
      


      Object.assign(boData, this.formData);
      boData = JSON.parse(JSON.stringify(boData));
      
      boData.CDFILICUSTO = this.formData.CDFILICUSTO ? this.formData.CDFILICUSTO.CDFILIAL : boData.CDFILIAL;
      boData.parsedCardapio = JSON.stringify("");
      boData.NRCENARIOVINCULO = null;
      
      delete boData.linkCommonDishesOptions;
      delete boData.calcUnitCostOptions;
      delete boData.costTypeOptions;
      delete boData.groupProdLimit;
      delete boData.groupProdLimitOptions;
      
      Util.setLocalVar("backOfficeData", boData);
      sessionStorage.setItem('filterData', JSON.stringify(boData));

      if(boData.linkCommonDishes){
      RegisteredDataController.getJsonDataOfSelectedScenary(boData.linkCommonDishes.NRCENARIOCARD).then(result => result).then(result =>{
        result = result.dataset.data;
        let jsonCenario = result && result[0] && result[0].JSONCENARIO;
        if(jsonCenario) {
            let parsedCardapio = JSON.parse(jsonCenario).cardapio;
            parsedCardapio.datas.forEach((d, dkey)  => {
              d.pratos.forEach((p, pkey) => {
                parsedCardapio.datas[dkey].pratos[pkey] = {codprato: p.codprato, sequencial: p.sequencial, nmprato: p.nomePrato};
              });
              parsedCardapio.datas[dkey] = {dia: d.dia, pratos: d.pratos}; 
            });
            boData.parsedCardapio = JSON.stringify(parsedCardapio);
            boData.NRCENARIOVINCULO = result[0].NRCENARIOCARD;
            delete boData.linkCommonDishes;
            Util.setLocalVar("backOfficeData", boData);
            sessionStorage.setItem('filterData', JSON.stringify(boData));
          }  
        });
      }
      
      //   Util.showNotification({
      //   	text:`Salvo às ${moment().format('HH:mm:ss')}`,
      //   	title:'Dados Salvos'
      //   })
    }
  },
  watch: {
    updateRegisteredData: function() {
      RegisteredDataController.getDefaultData(this);
      setTimeout(() => {
        this.onChangeDefaultCost();
        this.onChangeDnsConfig();
        this.onChangeMinPercent();
        this.onChangeMaxPercent();
        this.onChangeMinCost();
        this.onChangeMaxCost();
        this.getDataLinkCommonDishes();
        this.getDataCalcUnitCost();
        this.isNotFreezeble = this.checkFreezability(this.formData);
        // this.saveFormData();
      }, 100);
    }
  }
};
</script>

<style scoped lang="less">
.data-form {
  width: calc(100% - 30px);
  margin: 25px;
  height: 70vh;

  .field {
    display: inline-block;
    margin: 10px;
    text-align: left;
    font-size: 0.9rem;
    width: calc(100% - 45px);
    label{
      span{
          display: block;
          font-size: 0.8rem;
          color: gray;
        }
    }
    input {
      padding: 5px;
      border: 1px solid #bdbdbd;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;

      &.input-label {
        border: none;
        border-bottom: 1px solid #bdbdbd;
        border-radius: 0;
      }

      font-family: Arial;
      font-size: 0.9rem;
    }

    &.half {
      width: calc(50% - 35px);
    }

  }
}
</style>